import { useEffect, useState } from "react";

const WEBSOCKET_URL = "ws://localhost:8080";

function App() {
    const [socket, setSocket] = useState(null);
    const [messages, setMessages] = useState([]);
    const [inputMessage, setInputMessage] = useState("");
    const [recipientId, setRecipientId] = useState("");
    const [clientId, setClientId] = useState("");

    useEffect(() => {
        const ws = new WebSocket(WEBSOCKET_URL);
        setSocket(ws);

        ws.onopen = () => console.log("Connected to WebSocket server");

        ws.onmessage = async (event) => {
            const data = JSON.parse(event.data);
            console.log("Message received:", data);

            // Store assigned client ID
            if (data.type === "welcome") {
                setClientId(data.clientId);
            } else {
                setMessages(prev => [...prev, `${data.from || "Server"}: ${data.message || data.forwardedMessage}`]);
            }
        };

        ws.onclose = () => {
            console.log("WebSocket disconnected. Reconnecting...");
            setTimeout(() => setSocket(new WebSocket(WEBSOCKET_URL)), 3000);
        };

        return () => ws.close();
    }, []);

    const sendMessage = () => {
        if (socket && inputMessage.trim()) {
            const messageData = { message: inputMessage, to: recipientId || null };
            socket.send(JSON.stringify(messageData)); // Send JSON message
            setMessages(prev => [...prev, `You to ${recipientId || "All"}: ${inputMessage}`]);
            setInputMessage("");
        }
    };

    return (
        <div style={{ maxWidth: "400px", margin: "20px auto", textAlign: "center" }}>
            <h2>Chat App (Your ID: {clientId})</h2>
            <div style={{ border: "1px solid #ccc", padding: "10px", height: "300px", overflowY: "scroll" }}>
                {messages.map((msg, index) => <div key={index}>{msg}</div>)}
            </div>
            <input
                type="text"
                value={recipientId}
                onChange={(e) => setRecipientId(e.target.value)}
                placeholder="Recipient ID (leave blank for all)"
                style={{ width: "80%", padding: "5px", marginTop: "10px" }}
            />
            <input
                type="text"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                placeholder="Type a message..."
                style={{ width: "80%", padding: "5px", marginTop: "10px" }}
            />
            <button onClick={sendMessage} style={{ padding: "5px 10px", marginLeft: "10px" }}>Send</button>
        </div>
    );
}

export default App;
